import {
  Alert,
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import useStyles from "../common/model/styles";
import closeIcon from "../../assets/closeModel.png";
import checkedIcon from "../../assets/check-mark.png";
import deleteIcon from "../../assets/trash.png";

import Popup from "../common/model/Popup";
import React, { useEffect, useState } from "react";
import SubscriptionPlanForm from "../../clientAdmin/components/settings/manageClient/SubscriptionPlanForm";
import {
  subscriptionPlanFields,
  subscriptionUpgradePlanFields,
} from "./selectPlanFields";
import FormField from "../common/FormField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import {
  resetSubscriptionLocal,
  setNewSubscriptionLocal,
} from "../../store/reducers/publicSlice";
import {
  addSubscriptionAction,
  setAddSubscriptionAction,
} from "../../store/reducers/adminCreationSlice";
import Notification from "../common/notification/Notification";
import { useNavigate } from "react-router-dom";
import ResetFormAlert from "./ResetFormAlert";
import { getClientForEditAction } from "../../store/reducers/adminClientsSlice";
import { getUserProfile } from "../../store/reducers/userSlice";
import { setNotificationAction } from "../../store/reducers/mmymSlice";

interface ManageUpgradePlanProps {
  open: boolean;
  onHide: () => void;
  title: string;
  selectClient: any;
  action?: any;
  isNew?: boolean;
}

const ManageUpgradePlan = (props: ManageUpgradePlanProps) => {
  const { selectClient, onHide, open, title, isNew } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm");

  const { plans, newSubscriptionLocal } = useSelector(
    (state: any) => state.public
  );
  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients
  );

  const { user } = useSelector((state: any) => state?.user);

  const { isSubscriptionResponse, isSubscriptionResponseData } = useSelector(
    (state: any) => state.adminCreation
  );
  const [planChangeMessage, setPlanChangeMessage] = useState("");
  const [isdurationError, setIsdurationError] = useState(false);
  const [isPaymentError, setIsPaymentError] = useState(false);
  const [durationOptions, setDurationOptions] = useState([]);
  const [isChange, setIsChange] = useState(false);
  const [formData, setFormData]: any = React.useState({});
  const [isActionCalled, setIsActionCalled] = useState(false);

  const classes = useStyles();

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isCalledAction, setIsCalledAction] = useState(false);

  // NEW: control radio visibility
  const [showRefundOption, setShowRefundOption] = useState(false);

  const handleClear = () => {
    setAlertModelShow(true);
  };

  const hideHandler = () => {
    onHide();
    dispatch(resetSubscriptionLocal());
    setIsdurationError(false);
    setIsPaymentError(false);
    setShowRefundOption(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  // ✅ Prefill subscription details when client data is available
  useEffect(() => {
    if (editClientOriginalData && plans?.length > 0) {
      const {
        plan_name,
        subscription_duration,
        subscription_start_date,
        subscription_end_date,
        subscription_discount,
        subscription_paid_amount,
        subscription_payment_method,
        cost,
      } = editClientOriginalData;

      // 🔍 Check if the plan exists in the available plans
      const existingPlan = plans.find(
        (p: any) => p?.plan_name?.toLowerCase() === plan_name?.toLowerCase()
      );
      console.log("existing plan", existingPlan);
      // ✅ Check if selected client matches the same plan
      const isSameSelectedPlan = selectClient?.id === existingPlan?.id;
      if (existingPlan && isSameSelectedPlan) {
        // ✅ Prefill all details if plan name matches
        const prefillData = {
          planId: existingPlan?.id || "",
          duration: subscription_duration || "",
          startDate: subscription_start_date
            ? dayjs(subscription_start_date).format("YYYY-MM-DD")
            : "",
          endDate: subscription_end_date
            ? dayjs(subscription_end_date).format("YYYY-MM-DD")
            : "",
          discount: subscription_discount || existingPlan?.discount || 0,
          subscriptionCost: cost || existingPlan?.price || 0,
          amountPayable:
            subscription_paid_amount ||
            existingPlan?.price -
              (existingPlan?.price * (existingPlan?.discount || 0)) / 100,
          paymentMethod:
            subscription_payment_method || "Go Cardless Subscription",
          renewsOn: subscription_end_date
            ? dayjs(subscription_end_date).add(1, "day").format("YYYY-MM-DD")
            : "",
        };

        dispatch(setNewSubscriptionLocal(prefillData));
      } else {
        // ❗ If plan name doesn't match, only set planId (no other prefill)
        // If plan name doesn't match, prefill based on current subscription
        const startDate = subscription_end_date
          ? dayjs(subscription_end_date).add(1, "day").format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"); // fallback to today if no end date

        let endDate = "";
        if (subscription_duration === "yearly") {
          endDate = dayjs(startDate).add(1, "year").format("YYYY-MM-DD");
        } else if (subscription_duration === "monthly") {
          endDate = dayjs(startDate).add(1, "month").format("YYYY-MM-DD");
        } else {
          endDate = startDate; // fallback
        }

        dispatch(
          setNewSubscriptionLocal({
            ...newSubscriptionLocal,
            planId: selectClient?.id || "",
            duration: subscription_duration || "",
            startDate: startDate,
            endDate: endDate,
            discount: selectClient?.discount || 0,
            renewsOn: dayjs(endDate).add(1, "day").format("YYYY-MM-DD"),
          })
        );
        const message = `You will continue enjoying ${plan_name} features until your current ${subscription_duration} cycle ends.`;
        setPlanChangeMessage(message);
      }

      setIsCalledAction(false);
    }
  }, [editClientOriginalData, plans, dispatch, open, isCalledAction]);

  useEffect(() => {
    const selectedPlan = plans.find(
      (item: any) => item?.id === newSubscriptionLocal?.planId
    );

    // Build duration options, filter out "5D" if upgrading (isNew === false)
    const durationArray =
      selectedPlan && selectedPlan?.durations
        ? selectedPlan?.durations
            .filter((item: string) => isNew || item !== "5D")
            .map((item: any) => ({
              id: item,
              label:
                item === "5D"
                  ? "5 Days Trial"
                  : item === "3M"
                  ? "3 Months"
                  : item === "6M"
                  ? "6 Months"
                  : item === "12M"
                  ? "12 Months"
                  : item,
            }))
        : [];
    setDurationOptions(durationArray);

    // existing logic preserved (calculating subscriptionCost, start/end dates, etc.)
    let obj: any = {};
    if (newSubscriptionLocal?.duration && selectedPlan) {
      if (
        selectedPlan?.durations &&
        // IMPORTANT: check inclusion in the *filtered* durations (i.e., if 5D was filtered out, it won't be included)
        selectedPlan?.durations
          .filter((item: string) => isNew || item !== "5D")
          .includes(newSubscriptionLocal?.duration)
      ) {
        const totalConst: any =
          newSubscriptionLocal?.duration === "5D"
            ? 0
            : newSubscriptionLocal?.duration === "monthly"
            ? selectedPlan?.price * 1
            : newSubscriptionLocal?.duration === "yearly"
            ? selectedPlan?.price * 12
            : selectedPlan?.price * parseInt(newSubscriptionLocal?.duration);
        let cusStartDate = new Date().toISOString();
        let cusRenewsOn = "";
        let cusEndDate = "";

        if (newSubscriptionLocal?.duration === "5D") {
          const dT = dayjs(cusStartDate).add(
            parseInt(newSubscriptionLocal?.duration),
            "day"
          );
          cusEndDate = dT.format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        if (
          newSubscriptionLocal?.duration === "3M" ||
          newSubscriptionLocal?.duration === "6M" ||
          newSubscriptionLocal?.duration === "12M"
        ) {
          const dT = dayjs(cusStartDate).add(
            parseInt(newSubscriptionLocal?.duration),
            "month"
          );
          cusEndDate = dayjs(cusStartDate)
            .add(parseInt(newSubscriptionLocal?.duration), "month")
            .format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        if (newSubscriptionLocal?.duration === "monthly") {
          const dT = dayjs(cusStartDate).add(parseInt("1"), "month");
          cusEndDate = dayjs(cusStartDate)
            .add(parseInt("1"), "month")
            .format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        if (newSubscriptionLocal?.duration === "yearly") {
          const dT = dayjs(cusStartDate).add(parseInt("12"), "month");
          cusEndDate = dayjs(cusStartDate)
            .add(parseInt("12"), "month")
            .format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }

        obj = {
          subscriptionCost: totalConst,
          discount:
            newSubscriptionLocal?.duration === "5D"
              ? 0
              : !isChange
              ? newSubscriptionLocal?.discount
              : selectedPlan?.discount,
          amountPayable:
            newSubscriptionLocal?.duration === "5D"
              ? 0
              : selectedPlan?.discount && selectedPlan?.price
              ? totalConst -
                (totalConst *
                  (!isChange
                    ? newSubscriptionLocal?.discount
                    : selectedPlan?.discount)) /
                  100
              : "",
          startDate: isChange
            ? cusStartDate
            : newSubscriptionLocal?.startDate || "",
          endDate: isChange ? cusEndDate : newSubscriptionLocal?.endDate || "",
          renewsOn: isChange
            ? cusRenewsOn
            : newSubscriptionLocal?.renewsOn || "",
          paymentMethod: "Go Cardless Subscription",
        };
      } else {
        obj = {
          duration: "",
          subscriptionCost: "",
          discount: "",
          amountPayable: "",
          term: "",
          startDate: "",
          endDate: "",
          renewsOn: "",
        };
        setIsdurationError(true);
      }
      dispatch(
        setNewSubscriptionLocal({
          ...newSubscriptionLocal,
          ...obj,
        })
      );
    } else {
      if (selectedPlan) {
        setIsdurationError(true);
      }
    }
    // Also: set initial showRefundOption if current subscription was yearly AND new one is monthly
    const prevDuration =
      (selectClient &&
        (selectClient.duration ||
          selectClient.currentSubscription?.duration)) ||
      newSubscriptionLocal?.duration ||
      "";
    setShowRefundOption(
      prevDuration === "yearly" && newSubscriptionLocal?.duration === "monthly"
    );
  }, [plans, newSubscriptionLocal?.planId]); // keep same deps

  // Extract plan names from the plans array
  const plansName = plans.map((item: any) => ({
    id: item?.id,
    label: item?.plan_name,
  }));

  // Update the subscription field to include plan options
  const updatedFields = subscriptionUpgradePlanFields.map((field) => {
    if (field.id === "planId") {
      return { ...field, options: plansName, type: "select" };
    }
    return field;
  });

  // Clear option value when radio is hidden
  useEffect(() => {
    if (showRefundOption && !newSubscriptionLocal?.option) {
      dispatch(
        setNewSubscriptionLocal({
          ...newSubscriptionLocal,
          option: "REFUND",
        })
      );
    }

    if (!showRefundOption && newSubscriptionLocal?.option) {
      dispatch(
        setNewSubscriptionLocal({
          ...newSubscriptionLocal,
          option: "",
        })
      );
    }
  }, [showRefundOption]);

  const handleFormValueChange = (field: string, value: any) => {
    setIsChange(true);
    let obj: any = {};

    // Guard: prevent selecting trial when not new (shouldn't appear in options anyway)
    if (field === "duration" && value === "5D" && !isNew) {
      setIsdurationError(true);
      return;
    }

    if (field === "duration") {
      const selectedPlan = plans.find(
        (item: any) => item?.id === newSubscriptionLocal?.planId
      );

      // Determine previous/current duration for this customer
      const prevDuration =
        newSubscriptionLocal?.duration ||
        selectClient?.duration ||
        selectClient?.currentSubscription?.duration ||
        "";

      // Show radio only when changing from yearly -> monthly
      setShowRefundOption(prevDuration === "yearly" && value === "monthly");

      const totalConst: any =
        value === "5D"
          ? 0
          : value === "monthly"
          ? selectedPlan?.price * 1
          : value === "yearly"
          ? selectedPlan?.price * 12
          : selectedPlan?.price * parseInt(value);

      let cusStartDate = new Date().toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";

      if (value === "5D") {
        const dT = dayjs(cusStartDate).add(parseInt(value), "day");
        cusEndDate = dT.format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      if (value === "3M" || value === "6M" || value === "12M") {
        const dT = dayjs(cusStartDate).add(parseInt(value), "month");
        cusEndDate = dayjs(cusStartDate)
          .add(parseInt(value), "month")
          .format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      if (value === "monthly") {
        const dT = dayjs(cusStartDate).add(parseInt("1"), "month");
        cusEndDate = dayjs(cusStartDate)
          .add(parseInt("1"), "month")
          .format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      if (value === "yearly") {
        const dT = dayjs(cusStartDate).add(parseInt("12"), "month");
        cusEndDate = dayjs(cusStartDate)
          .add(parseInt("12"), "month")
          .format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }

      setIsdurationError(false);

      obj = {
        duration: value,
        subscriptionCost: totalConst,
        discount: value === "5D" ? 0 : selectedPlan?.discount,
        amountPayable:
          value === "5D"
            ? 0
            : selectedPlan?.discount && selectedPlan?.price
            ? totalConst - (totalConst * selectedPlan?.discount) / 100
            : "",
        term: [dayjs(cusStartDate), dayjs(cusEndDate)],
        startDate: cusStartDate,
        endDate: cusEndDate,
        renewsOn: cusRenewsOn,
        paymentMethod: "Go Cardless Subscription",
      };
    }

    if (field === "discount") {
      const selectedPlan = plans.find(
        (item: any) => item?.id === newSubscriptionLocal?.planId
      );
      const disValue = !value ? 0 : value;
      const totalConst: any =
        newSubscriptionLocal?.duration === "5D"
          ? 0
          : selectedPlan?.price * parseInt(newSubscriptionLocal?.duration);
      obj = {
        discount: value,
        amountPayable:
          newSubscriptionLocal?.duration === "5D"
            ? 0
            : disValue && selectedPlan?.price
            ? totalConst - (totalConst * disValue) / 100
            : totalConst,
      };
    }
    if (field === "term") {
      let cusStartDate = new Date(value).toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";
      if (newSubscriptionLocal["duration"] === "5D") {
        const dT = dayjs(cusStartDate).add(
          parseInt(newSubscriptionLocal["duration"]),
          "day"
        );
        cusEndDate = dT.format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      if (
        newSubscriptionLocal["duration"] === "3M" ||
        newSubscriptionLocal["duration"] === "6M" ||
        newSubscriptionLocal["duration"] === "12M" ||
        newSubscriptionLocal["duration"] === "monthly" ||
        newSubscriptionLocal["duration"] === "yearly"
      ) {
        const dT = dayjs(cusStartDate).add(
          parseInt(
            newSubscriptionLocal["duration"] === "monthly"
              ? "1"
              : newSubscriptionLocal["duration"] === "yearly"
              ? "12"
              : newSubscriptionLocal["duration"]
          ),
          "month"
        );
        cusEndDate = dT.format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      obj = {
        startDate: cusStartDate,
        endDate: cusEndDate,
        renewsOn: cusRenewsOn,
      };
    }

    dispatch(
      setNewSubscriptionLocal({
        ...newSubscriptionLocal,
        [field]: value,
        ...obj,
      })
    );
    setFormData((prevValues: any) => ({ ...prevValues, [field]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isdurationError && !isPaymentError) {
        // Create a copy excluding the fields you don't want
        const { startDate, endDate, renewsOn, term, ...submitData } =
          newSubscriptionLocal;

        console.log("submit data", submitData);

        dispatch(
          addSubscriptionAction({
            ...submitData,
            tenantId: user?.user?.tenantId,
          })
        );
        setIsActionCalled(false);
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (!isSubscriptionResponse) return;

    hideHandler();
    dispatch(setAddSubscriptionAction(false));

    if (isNew) {
      const nextAction = isSubscriptionResponseData?.nextAction;

      if (nextAction === "make_payment") {
        navigate("/payments");
      } else if (nextAction === "dashboard") {
        navigate(user?.user?.is_new ? "/settings" : "/dashboard");
      }
    } else {
      onHide();
      dispatch(getClientForEditAction());
      dispatch(getUserProfile());
    }

    dispatch(resetSubscriptionLocal());
  }, [isSubscriptionResponse, isNew, isSubscriptionResponseData, user]);

  return (
    <>
      <Popup
        open={open}
        title={props?.action === "plan" ? "Select Plan" : title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={handleClear}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <Notification />
            {updatedFields.map((field, i) => {
              // NEW: hide radio if not needed
              if (field.id === "option" && !showRefundOption) {
                return null;
              }

              // Skip rendering paymentMethod field if duration is "" or "5D"
              if (
                field.id === "paymentMethod" &&
                (newSubscriptionLocal?.duration === "" ||
                  newSubscriptionLocal?.duration === "5D")
              ) {
                return null;
              }

              return (
                selectClient && (
                  <Grid container spacing={2} key={i}>
                    <FormField
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(event: any) => {
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      labelPlacement={field?.labelPlacement || "top"}
                      {...{
                        ...(field?.id === "term" && {
                          renewsOn: newSubscriptionLocal["endDate"],
                        }),
                        ...field,
                        value: newSubscriptionLocal
                          ? field?.id === "term"
                            ? newSubscriptionLocal["startDate"]
                            : newSubscriptionLocal[field?.id]
                          : "",
                        defaultValue: newSubscriptionLocal
                          ? field?.id === "term"
                            ? newSubscriptionLocal["startDate"]
                            : newSubscriptionLocal[field?.id]
                          : "",
                        ...{
                          ...(field?.id === "duration" && {
                            options: durationOptions,
                          }),
                        },
                      }}
                      InputProps={{
                        ...(newSubscriptionLocal["duration"] === "5D" &&
                          field?.id === "discount" && { disabled: true }),
                        ...(newSubscriptionLocal["duration"] === "" &&
                          field?.id === "term" && { disabled: true }),
                        ...(newSubscriptionLocal["planId"] === "" &&
                          field?.id === "duration" && { disabled: true }),
                        sx:
                          field.type === "text" || field.type === "number"
                            ? { height: "36px" }
                            : { padding: "10px 4px", height: "36px" },
                      }}
                      selectedValues={formData[field.id]}
                      onChange={(e: any) =>
                        handleFormValueChange(field.id, e.target.value)
                      }
                      error={
                        field?.id === "duration"
                          ? isdurationError
                          : field?.id === "paymentMethod"
                          ? isPaymentError
                          : false
                      }
                    />
                  </Grid>
                )
              );
            })}
            {planChangeMessage && (
              <Alert severity="info" sx={{ mt: 2 }}>
                {planChangeMessage}
              </Alert>
            )}
            {newSubscriptionLocal?.duration !== "5D" &&
              newSubscriptionLocal?.duration !== "" && (
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    marginTop: "10px",
                    fontSize: "13px",
                  }}
                >
                  <span style={{ color: "#d97c7c" }}>
                    In case of Gocardless Subscription.:-{" "}
                  </span>
                  <br />
                  The client will receive an email with a payment link. Once
                  they pay the amount successfully, their Manage My Moves
                  subscription of £ {
                    newSubscriptionLocal?.amountPayable
                  } per{" "}
                  {newSubscriptionLocal?.duration === "monthly"
                    ? "month"
                    : " year"}{" "}
                  will be started.
                </Typography>
              )}
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          setIsCalledAction={setIsCalledAction}
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsdurationError={setIsdurationError}
          setIsPaymentError={setIsPaymentError}
        />
      )}
    </>
  );
};

export default ManageUpgradePlan;
